let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("1otv1"), load("3UXvk"), load("04gC2")]).then(() => parcelRequire('lqtku'));